import { render, staticRenderFns } from "./fi_notification_list.vue?vue&type=template&id=c2d2976e&"
import script from "./fi_notification_list.vue?vue&type=script&lang=js&"
export * from "./fi_notification_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports